module.exports = __webpack_public_path__ + "img/icon2.55b1daac.png";